export const POSITIVE_WORDS = [
  'yes',
  'hire',
  'strong',
  'strong hire',
  'excellent',
  'good',
  'recommend',
  'approve',
  'pass',
  'successful',
];
export const NEGATIVE_WORDS = [
  'no',
  'no hire',
  'reject',
  'weak',
  'poor',
  'fail',
  'unsuccessful',
  'decline',
  'deny',
];
export const NEUTRAL_WORDS = [
  'maybe',
  'lean hire',
  'consider',
  'review',
  'pending',
  'undecided',
  'neutral',
  'moderate',
];

export const getSentimentType = (text: string): 'positive' | 'negative' | 'neutral' => {
  const lowerText = text.toLowerCase();

  if (POSITIVE_WORDS.some(word => lowerText === word)) {
    return 'positive';
  }

  if (NEGATIVE_WORDS.some(word => lowerText === word)) {
    return 'negative';
  }

  if (NEUTRAL_WORDS.some(word => lowerText === word)) {
    return 'neutral';
  }

  return 'neutral';
};

export const getQualificationSentimentType = (
  text: string
): 'positive' | 'negative' | 'neutral' => {
  if (text === 'Strong Yes' || text === 'Yes') {
    return 'positive';
  }
  if (text === 'No') {
    return 'negative';
  }
  return 'neutral';
};

export const getSentimentStyles = (sentiment: 'positive' | 'negative' | 'neutral') => {
  switch (sentiment) {
    case 'positive':
      return {
        text: 'text-green-600',
        border: 'border-green-600',
        bg: 'bg-green-50',
      };
    case 'negative':
      return {
        text: 'text-red-600',
        border: 'border-red-600',
        bg: 'bg-red-50',
      };
    case 'neutral':
      return {
        text: 'text-yellow-600',
        border: 'border-yellow-600',
        bg: 'bg-yellow-50',
      };
  }
};
